/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { InitTotpPathParameters } from 'api/actions/init-totp/init-totp-path-parameters';
import { InitTotpResponse } from 'api/actions/init-totp/init-totp-response';

type InitTotpQueryParameters = Record<string, any>;

/**
 * The path of the InitTotp action.
 */
export const initTotpActionPath = new SweetPath<keyof InitTotpPathParameters>('/user/totp/init', { path: '{param}' });

/**
 * Creates a contextualized InitTotp actions.
 */
export default function createInitTotpAction(axios: AxiosInstance) {
  return function initTotpAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: InitTotpQueryParameters } = {}) {
    const path = initTotpActionPath.original;

    return axios.post<InitTotpResponse, InitTotpResponse>(path, { params: query, headers });
  };
}
